const collection = {
    slug: "glenn-martens-y-project-diesel-maison-margiela-guide",
    metaTitle:
      "Glenn Martens（グレンマーティンス）とは｜Y/Project・Diesel・Maison Margielaを変えた服の歪みと買取・レンタルガイド",
    metaDescription:
      "Glenn Martens（グレン・マーティンス）を徹底解説。ベルギー・ブルージュ出身、建築的背景、Jean Paul Gaultierでの経験、Y/Project、Diesel、Maison Margielaに至る経歴、デザインの特徴、思想、パーソナリティをEnclopedia独自の視点で読み解き、Y/Project買取、Diesel買取、Maison Margiela買取・レンタル導線へ案内します。",
    metaKeywords:
      "Glenn Martens,グレンマーティンス,グレン・マーティンス,Glenn Martens 経歴,Glenn Martens デザイン,Glenn Martens Maison Margiela,Maison Margiela Glenn Martens,メゾンマルジェラ グレンマーティンス,Maison Margiela 買取,メゾンマルジェラ 買取,Y/Project,Y Project,Y/Project Glenn Martens,Y Project 買取,ワイプロジェクト 買取,Diesel Glenn Martens,Diesel 買取,ディーゼル 買取,Jean Paul Gaultier Glenn Martens,グレンマーティンス 建築,グレンマーティンス ディーゼル,グレンマーティンス マルジェラ,グレンマーティンス ワイプロジェクト,アーカイブファッション,Enclopedia,アンクロペディア",
    canonicalPath:
      "/archive_collection/glenn-martens-y-project-diesel-maison-margiela-guide",
    heroImage:
      "media/archive_fashion/archive27.png",
    heroImageAlt:
      "Glenn Martens グレン・マーティンスの経歴とデザインを解説するEnclopediaアーカイブガイド画像",
    heroNumber: "28 / GLENN MARTENS",
    label: "ARCHIVE DESIGNER STUDY",
    title:
      "Glenn Martens｜Y/Project、Diesel、Maison Margielaをつなぐ“歪みの建築家”",
    lead:
      "Glenn Martens。\n\n彼を“変形デニムのデザイナー”や“Dieselを復活させた人”だけで捉えると、かなり浅くなります。\n\nMartensの本質は、服を壊すことではありません。\n服の中に、複数の着方、複数の人格、複数の時間を入れることにあります。\n\nY/Projectでは、シャツ、デニム、ニット、ブーツ、ジャケットといった日常的な服を、着る人が操作できる構造へ変えました。\nDieselでは、かつてのデニムブランドを、汚れ、擦れ、若さ、クラブ、巨大なショー、商業性を持つ現代的なエネルギーへ変換しました。\nMaison Margielaでは、脱構築、匿名性、再利用、身体の不完全さ、アルチザナルの記憶を、自分の建築的な感覚で引き受け始めています。\n\n彼の服は、きれいに完成していません。\nむしろ、途中で止まっているように見える。\nずれている。\nねじれている。\n引っ張られている。\n重なっている。\nほどけている。\n\nしかし、その未完成さが人を惹きつけます。\n\nEnclopediaでは、Glenn Martensを“奇抜なデザイナー”としてではなく、服を固定された完成品から、着る人が編集できる構造物へ変えたデザイナーとして読み解きます。",
    keywordLine: [
      "glenn martens",
      "y/project",
      "diesel",
      "maison margiela",
    ],
    thesis:
      "Glenn Martensの重要性は、服を一つの正解に固定せず、建築的構造、歪み、カスタマイズ性、デニム、クラブ感覚、脱構築を通じて、着る人自身が完成させる服へ変えた点にあります。",
    whyTitle:
      "なぜGlenn Martensは、Y/Project、Diesel、Maison Margielaを横断できたのか。",
    whyBody:
      "Glenn Martensのキャリアを追うと、彼が単なるトレンドデザイナーではないことが分かります。\n\nベルギー・ブルージュに生まれ、最初からファッションだけを目指していたわけではありません。\n彼は建築やインテリアデザインを学び、その後アントワープ王立芸術アカデミーへ進みます。\n\nこの建築的な出発点は、彼の服に強く残っています。\n\n服を平面的な布として見ない。\n身体の周囲に立つ構造として見る。\n引っ張る、ねじる、重ねる、開く、垂らす、固定する。\n\nY/Projectで彼が見せたのは、まさに服の構造を着る人へ開くことでした。\n服は一つの完成形ではなく、着るたびに違う形になる。\n\nDieselで彼が見せたのは、デニムという巨大な商業素材を、もう一度ファッションの中心へ引き戻すことでした。\nただのジーンズではなく、汚れ、歪み、加工、身体性、クラブ、若者文化を含むメディアとしてデニムを再起動した。\n\nMaison Margielaで彼が引き受けたのは、脱構築という最も危険な遺産です。\nMargielaは、すでに“マルジェラらしさ”として消費されすぎている。\nそこにMartensが入る意味は、脱構築を記号として繰り返すことではなく、もう一度、服と身体の関係を不安定にすることにあります。\n\nEnclopediaでは、この文脈を入口に、Y/Project、Diesel、Maison Margielaを、単なるブランド名ではなく、Martensがそれぞれの場所で何を変形させたのかという視点から読み解きます。",
    pillars: [
      {
        number: "01",
        title: "ARCHITECTURE OF DISTORTION",
        text:
          "Martensの服は、建築的です。ただし整った建築ではなく、引っ張られ、ねじれ、変形する建築です。身体の周囲に、歪んだ構造を作ります。",
      },
      {
        number: "02",
        title: "CUSTOMISABLE CLOTHING",
        text:
          "Y/Projectで確立した重要な特徴は、服を着る人に委ねることです。スナップ、ボタン、レースアップ、ワイヤー、重ねられた布によって、服は毎回違う形になります。",
      },
      {
        number: "03",
        title: "DENIM AS CULTURE",
        text:
          "Dieselでは、デニムを単なる日常着ではなく、若さ、汚れ、反抗、巨大な商業性を持つ文化装置として再提示しました。",
      },
      {
        number: "04",
        title: "MARGIELA AFTER MARGIELA",
        text:
          "Maison MargielaでのMartensは、脱構築を記号としてなぞるのではなく、素材、匿名性、再利用、身体の不完全さを通じて、Margielaを再び不安定にする役割を担っています。",
      },
    ],
    readingTitle:
      "ブルージュ、建築、Y/Project、Diesel、Maison Margiela、そして“歪み”から読むGlenn Martens。",
    readingIntro:
      "Glenn Martensを理解するには、Y/Project、Diesel、Maison Margielaを別々に見るだけでは足りません。彼の中では、建築、クラブ、デニム、脱構築、カスタマイズ性、商業性がつながっています。重要なのは、彼が服を“完成された商品”ではなく、“着る人が操作する構造物”として扱っていることです。",
    observations: [
      {
        index: "01",
        title:
          "Glenn Martensは、服を“建てる”デザイナーである",
        text:
          "Martensの出発点に建築・インテリアデザインがあることは、彼の服を読むうえで重要です。\n\n彼の服は、布を身体に沿わせるというより、身体の周囲に構造を建てるように作られています。\n\nシャツはねじれる。\nデニムは立ち上がる。\nジャケットはずれる。\nニットは引っ張られる。\nブーツはパンツと一体化する。\n\nつまり、彼にとって服は皮膚ではなく、構造体です。\n\nただし、それはモダニズム建築のように整った構造ではありません。\n歪み、余白、引っかかり、偶然の動きを含む建築です。\n\nEnclopediaでは、Martensを“服のデザイナー”というより、“身体の周囲に歪んだ建築を作るデザイナー”として見ます。",
      },
      {
        index: "02",
        title:
          "Y/Projectでは、服を一つの正解から解放した",
        text:
          "Y/ProjectにおけるMartensの最大の発明は、服を一つの着方に固定しなかったことです。\n\nスナップ。\nボタン。\nレースアップ。\nワイヤー。\n重ねられた布。\n開閉できる構造。\n\n服は、デザイナーが完成させるものではなく、着る人が毎回選ぶものになる。\n\n同じジャケットでも、閉じ方を変えれば違う輪郭になる。\n同じシャツでも、引っ張る位置を変えれば違う身体に見える。\n同じデニムでも、折れ方や落ち方で表情が変わる。\n\nY/Projectの服は、“正しい着方”を拒否します。\n\nここに、Martensの思想があります。\n服は完成品ではなく、着る人が編集する余白を持つべきなのです。",
      },
      {
        index: "03",
        title:
          "彼の歪みは、服を壊すためではなく、着る人を参加させるためにある",
        text:
          "Martensのデザインは、よく“歪んでいる”と語られます。\n\nしかし、この歪みは単なる奇抜さではありません。\n\n服がねじれていると、着る人は考えます。\nどう着ればいいのか。\nどこを留めればいいのか。\nどこを垂らせばいいのか。\nどこまで崩していいのか。\n\nつまり、歪みは着る人を参加させる仕組みです。\n\n普通の服は、着た瞬間に役割が決まります。\nMartensの服は、着た後にまだ決まっていない部分が残る。\n\nその未決定性が、彼の服をアーカイブとして面白くしています。",
      },
      {
        index: "04",
        title:
          "ワイヤー、スナップ、レースアップは、装飾ではなく編集機能である",
        text:
          "Martensの服に現れるワイヤー、スナップ、ボタン、レースアップは、単なるディテールではありません。\n\nそれらは、服を編集するための機能です。\n\nワイヤーは、布に固定された風やしわを作る。\nスナップは、服の開閉位置を変える。\nレースアップは、締める、緩める、ずらすという操作を可能にする。\n\nこのような構造によって、服は着る人の手に渡った後も変化し続けます。\n\nEnclopediaでは、こうしたディテールを“デザインの装飾”ではなく、“服に残された操作権”として見ます。",
      },
      {
        index: "05",
        title:
          "Y/Projectは、創業者の暗さからMartensのユーモアへ変わった",
        text:
          "Y/Projectは、もともとYohan Serfatyによる暗く、レザー色の強いブランドでした。\n\nMartensはそのブランドを引き継ぎながら、単純に別物へ変えたわけではありません。\n\n暗さは残した。\nしかし、そこにユーモア、デニム、カスタマイズ性、身体の遊びを加えた。\n\nこの転換が重要です。\n\nY/Projectは、ただゴシックで硬いブランドではなくなりました。\n着る人が遊べる、形を変えられる、奇妙なのに日常に入り込めるブランドになった。\n\nMartensの功績は、ブランドを明るくしたことではありません。\n暗さの中に、笑える余白を入れたことです。",
      },
      {
        index: "06",
        title:
          "Dieselで彼がしたのは、デニムを“若者の制服”へ戻すことだった",
        text:
          "DieselにおけるMartensの役割は、単にロゴを流行らせることではありませんでした。\n\nDieselは巨大なデニムブランドです。\nしかし、巨大であるがゆえに、かつての反抗性や若さが薄れていた時期もありました。\n\nMartensはそこに、汚れ、擦れ、肌、クラブ、巨大なランウェイ、開かれたショーの感覚を持ち込みました。\n\nデニムは再び、きれいな日常着ではなくなった。\n少し汚く、少し露骨で、少し下品で、しかし強烈に今の若さと結びついた。\n\nEnclopediaでは、Martens期Dieselを“商業的リブランディング”ではなく、“デニムの身体性を取り戻した時期”として見ます。",
      },
      {
        index: "07",
        title:
          "Dieselは、彼にとって巨大な実験場だった",
        text:
          "Y/Projectは、少数の人に深く届くブランドでした。\n\n一方でDieselは、より大きく、より商業的で、より多くの人へ届くブランドです。\n\nMartensにとってDieselは、実験を大衆化する場所でした。\n\nY/Project的な歪みをそのまま持ち込むのではなく、デニム、バッグ、ベルト、ロゴ、ショー演出へ翻訳する。\n\nここで重要なのは、彼が実験性を捨てなかったことです。\nむしろ、実験性を売れる形へ変えた。\n\nこの能力が、Maison Margielaへ進むうえで大きな説得力になりました。",
      },
      {
        index: "08",
        title:
          "Martensのパーソナリティは、複数の人格を同時に生きることにある",
        text:
          "Martensは、自分自身の中に複数の役割があることを語っています。\n\nビジネスマン。\nアーティスト。\n孫。\nゴッドファーザー。\nクラブキッド。\n\nこの発言は、単なるユーモアではありません。\n彼の服そのものを説明しています。\n\nMartensの服も、一つの人格に固定されません。\n\n真面目なのにふざけている。\n商業的なのに実験的。\nクラフト的なのにクラブっぽい。\n古典的なのに若い。\nラグジュアリーなのに汚れている。\n\n彼の服の多面性は、彼自身のパーソナリティの多面性とつながっています。",
      },
      {
        index: "09",
        title:
          "Maison Margielaは、Martensにとって最も自然で最も危険な場所である",
        text:
          "Maison Margielaは、Martensにとって自然な行き先に見えます。\n\nベルギー。\nアントワープ。\nJean Paul Gaultier。\n脱構築。\n匿名性。\n再利用。\n服の裏側を表に出す感覚。\n\n共通点は多い。\n\nしかし、だからこそ危険でもあります。\n\nMargielaらしさは、すでに世界中で消費され尽くしています。\n白いステッチ、足袋、脱構築、匿名性、古着の再利用。\n\nそれらをそのまま繰り返せば、ただの記号になります。\n\nMartensの仕事は、Margielaを“らしく”することではありません。\nMargielaをもう一度、分からないものに戻すことです。",
      },
      {
        index: "10",
        title:
          "MargielaでのMartensは、脱構築を“湿ったもの”へ戻している",
        text:
          "Martin Margielaの脱構築は、よく知的で乾いたものとして語られます。\n\n白。\n無名性。\n構造。\n裏返し。\n再利用。\n\n一方でMartensの脱構築には、湿度があります。\n\nゴシック。\nブルージュ。\n古い壁紙。\n地下室。\nレザー。\n錆びたような表面。\n身体にまとわりつく布。\n\n彼はMargielaの脱構築を、単なる概念に戻すのではなく、物質感と時間の汚れを持つものとして再提示しています。\n\nこれはEnclopedia的に非常に重要です。\nMartensのMargielaは、白い実験室ではなく、古い建物の壁から剥がれ落ちる素材のように始まっています。",
      },
      {
        index: "11",
        title:
          "彼の服には、常に“着る人の責任”が残る",
        text:
          "Martensの服は、親切ではありません。\n\n着る人に、どう着るかを考えさせます。\n\nボタンをどこで留めるか。\nどこを垂らすか。\nどこまで崩すか。\n何を前にして、何を後ろにするか。\n\nこれは不便でもあります。\nしかし、その不便さが服を面白くしています。\n\n完全に完成された服は、着る人を受け身にします。\nMartensの服は、着る人に責任を渡します。\n\nだから、同じ服でも着る人によって見え方が変わる。\n\nこの参加性こそ、Y/ProjectからMargielaまで続く彼の核です。",
      },
      {
        index: "12",
        title:
          "グレン・マーティンスのアーカイブ価値は、“分かりにくさ”にある",
        text:
          "アーカイブとして見たとき、Martensの服の価値は、分かりやすい名作性だけではありません。\n\nむしろ、分かりにくさにあります。\n\nこれはどう着るのか。\nどこが正面なのか。\nなぜここが開くのか。\nなぜデニムがこう折れているのか。\nなぜブーツとパンツがつながるのか。\n\nこの問いが残る服は、消費されにくい。\n\n一度見て終わるのではなく、もう一度見たくなる。\n着てみたくなる。\n手で触って構造を確かめたくなる。\n\nEnclopediaでは、この“問いが残る服”をレンタルや買取において重要なアーカイブ価値として扱います。",
      },
      {
        index: "13",
        title:
          "Y/Projectの終了によって、Martens期の価値はむしろ整理され始める",
        text:
          "Y/Projectが終了したことは、単なるブランドの終わりではありません。\n\nMartens期Y/Projectが、一つの閉じた時代として見られ始めるということでもあります。\n\n今後、Y/Projectのデニム、ワイヤー入りの服、変形シャツ、パンツブーツ、カスタマイズ性の高いピースは、より明確に“Martens期”として語られる可能性があります。\n\n現役ブランドとして追うのではなく、閉じたアーカイブとして振り返る段階に入る。\n\nこれは買取やレンタルにおいて重要です。\n\nまだ市場評価が完全に固まりきっていない今だからこそ、文脈を理解して拾う価値があります。",
      },
      {
        index: "14",
        title:
          "Diesel期は、量産とアーカイブの境界が最も面白い",
        text:
          "Dieselは巨大ブランドです。\nそのため、Martens期Dieselのすべてがアーカイブとして高く評価されるわけではありません。\n\nしかし、だからこそ見極めが重要です。\n\nショールックに近いデニム。\n加工が強いアイテム。\n1DRバッグのような象徴的プロダクト。\nロゴだけでなく、身体や汚れや歪みが表れている服。\n\nこれらは、単なる流行品ではなく、Dieselが再起動した時代の記録になります。\n\nEnclopediaでは、Dieselを安価なカジュアルブランドとしてだけでなく、Martensが商業と実験を接続した場所として見ます。",
      },
      {
        index: "15",
        title:
          "Maison Margiela期は、まだ評価が定まっていないからこそ重要である",
        text:
          "Maison MargielaでのMartensは、まだ始まったばかりです。\n\nしかし、初期の時点で重要なのは、彼がMargielaを単なる白衣的ミニマリズムへ戻していないことです。\n\nゴシック。\n湿った素材感。\n古い壁。\nマスク。\n再利用。\n身体の不完全さ。\n\nこれらを通じて、Margielaをもう一度、説明しにくいブランドへ戻そうとしている。\n\n今後、Martens期Margielaの初期作品は、後から振り返られる可能性があります。\n\nEnclopediaでは、初期の変化を追うこと自体が、将来的なアーカイブ価値を見極める入口になると考えます。",
      },
      {
        index: "16",
        title:
          "レンタルで分かるのは、歪みが自分の身体に合うかどうかである",
        text:
          "Martensの服は、写真で見るだけでは分かりません。\n\n歪んでいる。\n変形している。\n着方が複数ある。\n面白そうに見える。\n\nしかし、本当に重要なのは、それが自分の身体に乗ったときにどう見えるかです。\n\nワイヤーが作るしわ。\nデニムの重さ。\nパンツブーツの重心。\nシャツのねじれ。\nレースアップの締め方。\n\nこれらは、着てみなければ分からない。\n\nEnclopediaのレンタル体験は、Martensの服が“自分の生活に入る違和感”なのか、それとも“鑑賞するべき構造物”なのかを確かめる方法になります。",
      },
    ],
    quote:
      "Glenn Martensとは、服を壊すデザイナーではない。服に複数の着方と複数の人格を残し、着る人に完成を委ねるデザイナーです。",
    perspectiveTitle:
      "Enclopediaは、Glenn Martensを“奇抜なデザイナー”ではなく“服を操作可能な構造物へ変えた建築家的編集者”として扱う。",
    perspectiveCards: [
      {
        number: "01",
        title: "KNOWLEDGE",
        text:
          "Y/Project、Diesel、Maison Margielaまでの経歴を、建築、歪み、カスタマイズ性、デニム、脱構築という視点で整理します。",
      },
      {
        number: "02",
        title: "EXPERIENCE",
        text:
          "Martensの服は、実際に着ることで理解が深まります。ワイヤー、スナップ、レースアップ、デニムの重さ、歪みの出方をレンタルで体験できます。",
      },
      {
        number: "03",
        title: "ARCHIVE VALUE",
        text:
          "Martens期Y/Project、Diesel、Maison Margiela初期は、今後アーカイブ価値が整理されていく領域です。Enclopediaでは時期と文脈まで含めて確認します。",
      },
    ],
    experienceTitle:
      "Glenn Martens関連アイテムを売る前に、その一着がどの“歪み”を持つかを確認する。",
    experienceBody:
      "Glenn Martens関連アイテムの買取では、ブランド名だけでなく、どの時期の作品か、どの文脈にあるかが重要です。\n\nY/Projectであれば、変形デニム、ワイヤー入りの服、パンツブーツ、レースアップ、スナップ、複数の着方ができるピース。\nDieselであれば、Martens期の加工デニム、1DRバッグ、ショールックに近いアイテム、歪みや汚れの美学が強い服。\nMaison Margielaであれば、Martens初期のアルチザナル、マスク、再利用素材、ゴシックな表面、脱構築の解釈。\n\nそれぞれ評価軸が異なります。\n\nEnclopediaでは、Glenn Martensを単なる人気デザイナーとしてではなく、服を“着る人が編集する構造物”へ変えた人物として見ます。\nそのため、査定では状態、相場、付属品だけでなく、時期、シーズン、デザインの特徴、今後のアーカイブ価値まで確認します。",
    experienceItems: [
      "Y/Project、Diesel、Maison Margielaなどブランド名とタグを確認する",
      "Glenn Martens期かどうか、シーズンや購入時期を確認する",
      "Y/Projectの変形デニム、ワイヤー入りアイテム、パンツブーツ、カスタマイズ可能な服は構造が分かる写真を撮影する",
      "DieselのMartens期デニム、1DRバッグ、強い加工、ショールックに近いアイテムは全体とディテールを撮影する",
      "Maison MargielaのMartens初期アイテムはタグ、シーズン、付属品、アルチザナル性、再利用素材の有無を確認する",
      "スナップ、ボタン、レースアップ、ワイヤー、二重構造、変形パターンなどのディテールを撮影する",
      "状態、汚れ、擦れ、型崩れ、デニムの加工、レザーの傷、金具、保存袋、箱、レシートの有無を確認する",
      "Glenn Martens期か不明な場合もLINEで写真を送る",
    ],
    archiveItemsTitle:
      "Glenn Martensを入口に、Y/Project・Diesel・Maison Margielaの買取・レンタルへ。",
    archiveItemsBody:
      "Enclopediaでは、Glenn Martens関連アイテムを単なるブランド古着としてではなく、Y/Projectでの歪み、Dieselでのデニム再起動、Maison Margielaでの脱構築の再編集まで含めて見ています。この記事でGlenn Martensの重要性に触れた方は、所有している関連アイテムも、まずはLINEでご相談ください。",
    archiveItems: [
      {
        label: "BUYBACK FOCUS 01",
        title: "Maison Margiela,Y/Project、Dieselの価値を相談する",
        productPath:
          "https://line.me/R/ti/p/@240yzqkh",
        productImage: "",
        text:
          "Y/Projectの変形デニム、ワイヤー入りアイテム、パンツブーツ、レースアップ、複数の着方ができる服まで。Martens期の文脈込みで確認します。",
      },
      {
        label: "BUYBACK FOCUS 03",
        title: "Maison Margiela買取ページへ",
        productPath:
          "/brand_buyback/maison-margiela",
        productImage: "",
        text:
          "Maison Margielaの足袋、ジャケット、ニット、バッグ、アルチザナル性のあるアイテム、Glenn Martens初期のピースまで。マルジェラの買取対象と査定視点を確認できます。",
      },
      {
        label: "RENTAL FOCUS 04",
        title: "レンタルできるMaison Margielaを見る",
        productPath:
          "/brand/MAISON%20MARGIELA（メゾンマルジェラ）/?number=12",
        productImage: "",
        text:
          "Maison Margielaの構造、匿名性、足袋、脱構築的なデザインは、実際に着ることで理解が深まります。Enclopediaでマルジェラのアーカイブを体験できます。",
      },
    ],
    finalCta: {
      title:
        "Glenn Martensを読んだら、次はその一着の“歪み”を相談する。",
      body:
        "Glenn Martensは、Y/Project、Diesel、Maison Margielaを通じて、服を一つの完成品ではなく、着る人が操作する構造物へ変えてきたデザイナーです。\nEnclopediaでは、関連アイテムをブランド名だけでなく、時期、シーズン、構造、デニム、カスタマイズ性、今後のアーカイブ価値まで含めて確認します。\nまずはLINEでタグ・品質表示・全体写真・付属品をお送りください。",
      buttonLabel: "Glenn Martens関連アイテムをLINEで相談する",
      buttonHref: "https://line.me/R/ti/p/@240yzqkh",
    },
  };
  
  export default collection;